import { createContext, useContext } from 'react';
import { useGeoWatch } from './useGeoWatch';

/*
 * One GPS watch for Field Mode (docs/GAME_DESIGN.md Part III section 19).
 *
 * pages/Field.js follows the phone's position here, once, while the camera
 * or a live event is on screen; the camera and the event's view read it from
 * here, so switching between them neither starts a second watch nor waits
 * for a first fix again. Outside the provider (a test rendering the camera
 * alone) useFieldGeo keeps a watch of its own, as the camera always did.
 */
const FieldGeoContext = createContext(null);

export function FieldGeoProvider({ active, children }) {
  const geo = useGeoWatch(active);
  return <FieldGeoContext.Provider value={geo}>{children}</FieldGeoContext.Provider>;
}

/** {fix, fixRef, state}: the provider's, else this component's own watch. */
export function useFieldGeo() {
  const shared = useContext(FieldGeoContext);
  const own = useGeoWatch(!shared);
  return shared || own;
}
